import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';
import { addressInitialState, AddressStateProps, addressStateStore } from './address-state.store';

@Injectable({
  providedIn: 'root',
})
export class AddressRepository extends BaseStoreRepository<AddressStateProps> {
  constructor() {
    super(addressStateStore.pipe(select(state => state)), addressStateStore, addressInitialState);
  }
}
